<template>
  <div class="navbar-top">
    <!-- <div class="navabr-top-notify" @click="openNotify">
      <img src="@/assets/images/Navbar/Notify.svg" alt="Notify" />
      <div v-if="hasNotify" class="notify-count">{{ notifyCount }}</div>
    </div> -->
    <!-- <div class="navbar-top-photo"></div> -->
    <div class="flex-between-center">
      <button
        type="button"
        class="navbar-mobile-toggle"
        aria-label="開啟導覽選單"
        :aria-expanded="isMobileNavbarOpen"
        @click.stop="openNavbarMobile"
      >
        <div style="width: 100%; height: 3px; background-color: #d1d1d1"></div>
        <div style="width: 100%; height: 3px; background-color: #d1d1d1"></div>
        <div style="width: 100%; height: 3px; background-color: #d1d1d1"></div>
      </button>
      <div class="navbar-mobile-logo" @click="backToHome">
        <img
          class="navbar-logo-img"
          src="@/assets/images/Navbar/Ushow_logo.svg"
          alt="Ushow"
        />
      </div>
    </div>
    <div class="flex-center-center position-relative cursor-pointer">
      <div class="go-old-cloud">
        <a
          :href="manualUrl"
          class="manual-hover"
          data-title="說明書"
          target="_blank"
          ><img :src="$img.get('Tools/Manual.svg')" alt="Manual"
        /></a>
      </div>
      <div class="navbar-top-username" @click="openUserModal">
        {{ userName
        }}<img :src="$img.get('Icon/ListToggle.svg')" alt="ListToggle" />
      </div>
      <dialogModal
        id="userDialogModal"
        style="top: 32px; transform: translateX(-45%)"
        :trigger="dialogModalTrigger"
        :conditionTypes="dialogTypes"
        @addCondition="clickDialogOption"
      ></dialogModal>
    </div>
    <div
      ref="navbarGrayLayer"
      class="navbar-gray-layer"
      @click="closeNavbarMobile"
    ></div>
    <div
      ref="navbarMobileContainer"
      class="navbar-mobile-container hide-navbar-mobile"
    >
      <div class="close-btn" @click="closeNavbarMobile">×</div>
      <div class="navbar-mobile-groups">
        <div
          v-if="isNavbarLoading && !filteredNavbars.length"
          class="navbar-mobile-status"
        >
          選單載入中...
        </div>
        <div
          v-else-if="navbarItemsLoaded && !filteredNavbars.length"
          class="navbar-mobile-status"
        >
          目前沒有可使用的選單
        </div>
        <template v-if="filteredNavbars.length">
          <div
            v-for="nav in filteredNavbars"
            :key="nav.value"
            :id="`navMob${nav.name}`"
            class="navbar-mobile-group-container group-hidden-height"
          >
            <div
              class="navbar-mobile-group"
              @click="openNavbarMobileGroup(nav.name)"
            >
              {{ nav.text }}
            </div>
            <div
              v-if="nav.value === 0 || nav.value === 2"
              class="navbar-mobile-links"
            >
              <div
                v-for="cate in nav.categories"
                :key="cate.name"
                class="navbar-mobile-link"
              >
                <router-link
                  :to="{ name: cate.name }"
                  @click="closeNavbarMobile"
                  >{{ cate.text }}</router-link
                >
              </div>
            </div>
            <div v-else class="navbar-mobile-links">
              <div
                v-for="cate in nav.categories"
                :key="cate.name"
                :class="cate.subcategories ? 'w-100' : 'navbar-mobile-link'"
              >
                <div
                  v-if="cate.subcategories"
                  :id="`navMobSub${cate.name}`"
                  class="navbar-mobile-sub-group-container sub-group-hidden-height"
                >
                  <div
                    class="navbar-mobile-sub-group"
                    @click="openNavbarMobileSubGroup(cate.name)"
                  >
                    {{ cate.text }}
                  </div>
                  <div class="navbar-mobile-sub-links">
                    <div
                      v-for="subCate in cate.subcategories"
                      :key="subCate.name"
                      class="navbar-mobile-sub-link"
                    >
                      <router-link
                        :to="{ name: subCate.name }"
                        @click="closeNavbarMobile"
                        >{{ subCate.text }}</router-link
                      >
                    </div>
                  </div>
                </div>
                <router-link
                  v-else
                  :to="{ name: cate.name }"
                  @click="closeNavbarMobile"
                  >{{ cate.text }}</router-link
                >
              </div>
            </div>
          </div>
        </template>
        <div
          v-if="isGeneralUser && hasComponentDevelopmentPage"
          class="navbar-mobile-group-container group-hidden-height"
        >
          <div class="navbar-mobile-group" @click="clickComponentDevelopment">
            元件開發
          </div>
        </div>
        <div
          v-if="!isGeneralUser && hasManualPage"
          class="navbar-mobile-group-container group-hidden-height"
        >
          <div class="navbar-mobile-group" @click="clickManual">說明書</div>
        </div>
      </div>
    </div>
  </div>
  <div class="navbar-left">
    <div ref="navbarActiveContent" class="navbar-content">
      <div ref="navbarActiveSubContent" class="navbar-active-sub-content">
        <div class="navbar-active-sub-content-items">
          <div
            v-for="(subcategory, index) in subGroup.subcategories"
            :key="`${subcategory.name}-${index}`"
          >
            <div
              v-if="subcategory.borderLine"
              class="w-100"
              style="margin: 5px 0; border-bottom: 1px solid #9bb0bf80"
            ></div>
            <div
              :id="subcategory.name"
              class="navbar-active-sub-content-item"
              @click="changeRoute(subcategory)"
            >
              <div class="text">
                {{ subcategory.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="navbar-active-main-content">
        <div
          v-for="(category, index) in group.categories"
          :key="`${category.name}-${index}`"
        >
          <div
            v-if="category.borderLine"
            class="w-100"
            style="margin: 5px 0; border-bottom: 1px solid #9bb0bf80"
          ></div>
          <div
            :id="category.name"
            class="navbar-active-main-content-item"
            @click="showSubContent(group.value, category)"
          >
            <div class="text">{{ category.text }}</div>
            <div v-if="category.subcategories" class="arrow mt-2px">
              <img :src="arrowRight" alt="ArrowRight" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="navbar-list">
      <div class="navbar-logo" @click="backToHome">
        <img
          class="navbar-logo-img"
          src="@/assets/images/Navbar/Ushow_logo.svg"
          alt="Ushow"
        />
      </div>
      <div
        class="navbar-links"
        :class="{
          'component-development-enabled': hasComponentDevelopmentPage,
        }"
      >
        <template v-if="isGeneralUser">
          <div
            id="Basic"
            class="navbar-link swipable"
            @click="showNavbarActiveContent(0)"
          >
            <div class="navbar-link-icon">
              <img
                class="navbar-link-icon-default"
                :src="require('@/assets/images/Navbar/Basic.svg')"
                alt="Basic"
              />
              <img
                class="navbar-link-icon-active"
                :src="require('@/assets/images/Navbar/Basic_active.svg')"
                alt="Basic_active"
              />
            </div>
            <div class="navbar-link-name">基本資料</div>
          </div>
          <div
            v-if="
              filteredNavbars && filteredNavbars.find((nav) => nav.value == 1)
            "
            id="Report"
            class="navbar-link swipable"
            @click="showNavbarActiveContent(1)"
          >
            <div class="navbar-link-icon">
              <img
                class="navbar-link-icon-default"
                :src="require('@/assets/images/Navbar/Report.svg')"
                alt="Report"
              />
              <img
                class="navbar-link-icon-active"
                :src="require('@/assets/images/Navbar/Report_active.svg')"
                alt="Report_active"
              />
            </div>
            <div class="navbar-link-name">報表</div>
          </div>
          <div
            v-if="
              filteredNavbars && filteredNavbars.find((nav) => nav.value == 2)
            "
            id="Customer"
            class="navbar-link swipable"
            @click="showNavbarActiveContent(2)"
          >
            <div class="navbar-link-icon">
              <img
                class="navbar-link-icon-default"
                :src="require('@/assets/images/Navbar/Member.svg')"
                alt="Member"
              />
              <img
                class="navbar-link-icon-active"
                :src="require('@/assets/images/Navbar/Member_active.svg')"
                alt="Member_active"
              />
            </div>
            <div class="navbar-link-name">會員</div>
          </div>
          <div
            v-if="
              ERPName &&
              filteredNavbars &&
              filteredNavbars.find((nav) => nav.value == 3)
            "
            id="ERP"
            class="navbar-link swipable"
            @click="showNavbarActiveContent(3)"
          >
            <div class="navbar-link-icon">
              <img
                class="navbar-link-icon-default"
                :src="require('@/assets/images/Navbar/ERP.svg')"
                alt="ERP"
              />
              <img
                class="navbar-link-icon-active"
                :src="require('@/assets/images/Navbar/ERP_active.svg')"
                alt="ERP_active"
              />
            </div>
            <div class="navbar-link-name">{{ ERPName }}</div>
          </div>
          <div
            v-if="
              filteredNavbars && filteredNavbars.find((nav) => nav.value == 4)
            "
            id="Account"
            class="navbar-link swipable"
            @click="showNavbarActiveContent(4)"
          >
            <div class="navbar-link-icon">
              <img
                class="navbar-link-icon-default"
                :src="require('@/assets/images/Navbar/Account.svg')"
                alt="Account"
              />
              <img
                class="navbar-link-icon-active"
                :src="require('@/assets/images/Navbar/Account_active.svg')"
                alt="Account_active"
              />
            </div>
            <div class="navbar-link-name">帳款</div>
          </div>
          <div
            v-if="
              (hasUberEats || hasOcard || hasKDSServer) &&
              filteredNavbars &&
              filteredNavbars.find((nav) => nav.value == 5)
            "
            id="OnlineOrder"
            class="navbar-link swipable"
            @click="showNavbarActiveContent(5)"
          >
            <div class="navbar-link-icon">
              <img
                class="navbar-link-icon-default"
                :src="require('@/assets/images/Navbar/OnlineOrder.svg')"
                alt="OnlineOrder"
              />
              <img
                class="navbar-link-icon-active"
                :src="require('@/assets/images/Navbar/OnlineOrder_active.svg')"
                alt="OnlineOrder_active"
              />
            </div>
            <div class="navbar-link-name">串接</div>
          </div>
          <div
            v-if="hasDownload"
            id="Download"
            class="navbar-link"
            @click="clickDownload"
          >
            <div class="navbar-link-icon">
              <img
                class="navbar-link-icon-default"
                :src="require('@/assets/images/Navbar/Download.svg')"
                alt="Download"
              />
              <img
                class="navbar-link-icon-active"
                :src="require('@/assets/images/Navbar/Download_active.svg')"
                alt="Download_active"
              />
            </div>
            <div class="navbar-link-name">下傳</div>
          </div>
          <div
            v-if="hasComponentDevelopmentPage"
            id="ComponentDevelopment"
            class="navbar-link"
            @click="clickComponentDevelopment"
          >
            <div class="navbar-link-icon">
              <img
                class="navbar-link-icon-default"
                :src="require('@/assets/images/Navbar/Module.svg')"
                alt="ComponentDevelopment"
              />
              <img
                class="navbar-link-icon-active"
                :src="require('@/assets/images/Navbar/Module_active.svg')"
                alt="ComponentDevelopment_active"
              />
            </div>
            <div class="navbar-link-name">元件開發</div>
          </div>
        </template>
        <template v-else>
          <div
            v-for="nav in filteredNavbars"
            :id="nav.name"
            :key="nav.value"
            class="navbar-link swipable"
            @click="showNavbarActiveContent(nav.value)"
          >
            <div class="navbar-link-icon">
              <img
                class="navbar-link-icon-default"
                :src="internalNavbarIcon(nav.name).default"
                :alt="nav.name"
              />
              <img
                class="navbar-link-icon-active"
                :src="internalNavbarIcon(nav.name).active"
                :alt="`${nav.name}_active`"
              />
            </div>
            <div class="navbar-link-name">{{ nav.text }}</div>
          </div>
        </template>
        <div
          v-if="!isGeneralUser && hasManualPage"
          id="Manual"
          class="navbar-link"
          :class="{ active: $route.name === 'Manual' }"
          @click="clickManual"
        >
          <div class="navbar-link-icon">
            <img
              class="navbar-link-icon-default"
              :src="require('@/assets/images/Navbar/Report.svg')"
              alt="Manual"
            />
            <img
              class="navbar-link-icon-active"
              :src="require('@/assets/images/Navbar/Report_active.svg')"
              alt="Manual_active"
            />
          </div>
          <div class="navbar-link-name">說明書</div>
        </div>
      </div>
    </div>
  </div>
  <itemModal
    id="userModal"
    modalTitle="使用者"
    modalClass="modal-sm"
    modalBodyClass="px-0"
    :trigger="userModalTrigger"
    @onSaved="saveUser"
    @onClosed="userModalTrigger = !userModalTrigger"
  >
    <template #modal-body>
      <div class="inputs-group">
        <inputTextPart class="w-50" title="名稱" :isRequired="true">
          <input type="text" v-model="user.UserName" required />
        </inputTextPart>
        <inputTextPart class="w-50" title="信箱">
          <input type="email" v-model="user.Email" />
        </inputTextPart>
        <inputTextPart class="w-50" title="帳號">
          <input type="text" v-model="user.Account" readonly />
        </inputTextPart>
      </div>
    </template>
  </itemModal>
  <itemModal
    id="passwordModal"
    modalTitle="修改密碼"
    modalClass="modal-sm"
    modalBodyClass="px-0"
    :trigger="passwordModalTrigger"
    @onSaved="savePassword"
    @onClosed="passwordModalTrigger = !passwordModalTrigger"
  >
    <template #modal-body>
      <div class="inputs-group">
        <inputTextPart class="w-100" title="舊密碼" :isRequired="true">
          <input type="password" v-model="user.OldPassword" required />
        </inputTextPart>
        <inputTextPart class="w-100" title="新密碼" :isRequired="true">
          <input type="password" v-model="user.NewPassword" required />
        </inputTextPart>
        <inputTextPart class="w-100" title="確認新密碼" :isRequired="true">
          <input type="password" v-model="checkPassword" required />
        </inputTextPart>
      </div>
    </template>
  </itemModal>
</template>

<script>
import dialogModal from "@/components/modals/DialogModal.vue";
import itemModal from "@/components/modals/ItemModal.vue";
import inputTextPart from "@/components/parts/inputs/InputTextPart.vue";
export default {
  data() {
    return {
      arrowRight: this.$img.get("Icon/ArrowRight.svg"),
      navbars: [],
      filteredNavbars: [],
      group: {},
      subGroup: {},
      notifyCount: 1,
      dialogModalTrigger: false,
      userModalTrigger: false,
      passwordModalTrigger: false,
      user: {},
      checkPassword: "",
      manualUrl: "https://help.ushowpos.com/",
      internalNavbarIcons: {
        OldVersionBasic: {
          default: require("@/assets/images/Navbar/Basic.svg"),
          active: require("@/assets/images/Navbar/Basic_active.svg"),
        },
        OldVersionLogs: {
          default: require("@/assets/images/Navbar/Report.svg"),
          active: require("@/assets/images/Navbar/Report_active.svg"),
        },
        OldVersionAccount: {
          default: require("@/assets/images/Navbar/Account.svg"),
          active: require("@/assets/images/Navbar/Account_active.svg"),
        },
      },
      mobileNavbarCloseTimer: null,
      mobileNavbarTransitionHandler: null,
      isMobileNavbarOpen: false,
      isNavbarLoading: false,
      navbarItemsLoaded: false,
    };
  },
  components: {
    dialogModal,
    itemModal,
    inputTextPart,
  },
  computed: {
    dialogTypes() {
      let arr = [];
      if (this.isGeneralUser) {
        arr = [
          {
            value: 1,
            name: "User",
            text: "使用者",
          },
          {
            value: 2,
            name: "Password",
            text: "修改密碼",
          },
          {
            value: 0,
            name: "Logout",
            text: "登出",
          },
        ];
      } else {
        arr = [
          {
            value: 0,
            name: "Logout",
            text: "登出",
          },
        ];
      }
      return arr;
    },
    userName() {
      return window.localStorage["userName"];
    },
    hasNotify() {
      return true;
    },
    hasLY() {
      return window.localStorage["erpType"] == 1;
    },
    hasDWAPI() {
      return window.localStorage["erpType"] == 3;
    },
    isERP() {
      return window.localStorage["isERP"] == "true";
    },
    productType() {
      return parseInt(window.localStorage["productType"]);
    },
    hasCloudElecInvoice() {
      return window.localStorage["hasCloudElecInvoice"] == "true";
    },
    hasOcard() {
      return window.localStorage["hasOcard"] == "true";
    },
    hasUberEats() {
      return window.localStorage["hasUberEats"] == "true";
    },
    hasKDSServer() {
      return window.localStorage["hasKDSServer"] == "true";
    },
    ERPName() {
      return this.hasLY
        ? "凌越進銷存"
        : this.hasDWAPI
        ? "鼎新進銷存"
        : this.isERP
        ? "進銷存"
        : this.productType == 3 || this.hasCloudElecInvoice
        ? "單據"
        : undefined;
    },
    hasDownload() {
      return this.navbars.some(
        (item) => item.name == "Download" && item.isShow
      );
    },
    hasComponentDevelopmentPage() {
      return process.env.NODE_ENV === "development";
    },
    hasManualPage() {
      return process.env.NODE_ENV === "development";
    },
    isGeneralUser() {
      return this.$enum.roleType.isGeneralUser();
    },
  },
  watch: {
    $route() {
      this.closeNavbarMobile();
    },
    dialogModalTrigger(value) {
      if (value) {
        this.$nextTick(() => {
          document.addEventListener("click", this.closeUserModal, true);
        });
      } else {
        document.removeEventListener("click", this.closeUserModal, true);
      }
    },
  },
  methods: {
    internalNavbarIcon(name) {
      return (
        this.internalNavbarIcons[name] ||
        this.internalNavbarIcons.OldVersionBasic
      );
    },
    filterNode() {
      const filterNode = (node) => {
        // 如果有 subcategories，就過濾它們
        if (node.subcategories) {
          const filteredSub = node.subcategories.filter(
            (sub) => sub.isShow === undefined || sub.isShow
          );
          if (filteredSub.length === 0) return null; // subcategories 全部被過濾，就丟掉這個 node
          return {
            ...node,
            subcategories: filteredSub,
          };
        }

        // 如果有 categories，就遞迴處理
        if (node.categories) {
          const filteredCate = node.categories
            .map(filterNode)
            .filter((x) => x !== null);
          if (filteredCate.length === 0) return null;
          return {
            ...node,
            categories: filteredCate,
          };
        }

        // 沒有子層，直接判斷 isShow
        if (node.isShow === false) return null;
        return node;
      };

      // 對 navbars 每一層做遞迴過濾
      return this.navbars.map(filterNode).filter((x) => x !== null); // nav 都空了的話也會移除（可選）
    },
    openUserModal() {
      if (!this.dialogModalTrigger) {
        this.dialogModalTrigger = true;
      }
    },
    closeUserModal() {
      this.dialogModalTrigger = false;
    },
    async clickDialogOption(type) {
      if (type.value == 0) {
        try {
          await this.$api.userAccounts.logout();
        } catch {
          // 登出紀錄失敗時仍需完成本機登出。
        } finally {
          this.$router.push("/login");
        }
      } else if (type.value == 1) {
        this.$api.users.get(window.localStorage["userId"]).then((data) => {
          this.user = data;
          this.userModalTrigger = !this.userModalTrigger;
        });
      } else if (type.value == 2) {
        this.passwordModalTrigger = !this.passwordModalTrigger;
      }
    },
    saveUser() {
      this.user.UserId = window.localStorage["userId"];
      this.user.Password = this.$func.crypto.encrypt(this.password);
      const vm = this;
      this.$api.users
        .update(vm.user.UserId, vm.user)
        .then(() => {
          vm.userModalTrigger = !vm.userModalTrigger;
          if (window.localStorage["userId"] == vm.user.UserId)
            window.localStorage["userName"] = vm.user.UserName;
          vm.$emit("onSaved", vm.user.UserId);
        })
        .catch((error) => {
          vm.$func.message({
            type: "error",
            mainMessage: error.data.Message,
          });
        });
    },
    savePassword() {
      if (this.user.OldPassword === this.user.NewPassword) {
        this.$func.message({
          type: "alert",
          mainMessage: "新密碼不可與舊密碼相同 !",
        });
        return;
      }

      if (this.checkPassword != this.user.NewPassword) {
        this.$func.message({
          type: "alert",
          mainMessage: "請輸入相同密碼 !",
        });
        return;
      }
      let dTO = {};
      dTO.OldPassword = this.$func.crypto.encrypt(this.user.OldPassword);
      dTO.NewPassword = this.$func.crypto.encrypt(this.user.NewPassword);
      const vm = this;
      this.$api.users
        .changePassword(dTO)
        .then(() => {
          vm.passwordModalTrigger = !vm.passwordModalTrigger;
        })
        .catch((error) => {
          vm.$func.message({
            type: "error",
            mainMessage: error.data.Message,
          });
        });
    },
    clickDownload() {
      this.hideNavbarActiveContent();
      const item = this.filteredNavbars.find((nav) => {
        return nav.value == 6;
      });
      this.$router.push({
        name: item.name,
      });
    },
    clickComponentDevelopment() {
      this.hideNavbarActiveContent();
      this.closeNavbarMobile();
      if (this.$route.name != "ComponentDevelopment") {
        this.$router.push({ name: "ComponentDevelopment" });
      }
    },
    clickManual() {
      this.closeNavbarMobile();
      if (this.$route.name != "Manual") {
        this.$router.push({ name: "Manual" });
      }
    },
    openNavbarMobileGroup(name) {
      const groups = document.querySelectorAll(
        ".navbar-mobile-group-container"
      );
      groups.forEach((group) => {
        if (group.id !== `navMob${name}`) {
          // 收起其他項目
          if (!group.classList.contains("group-hidden-height")) {
            group.style.height = group.scrollHeight + "px"; // 設定初始高度
            group.offsetHeight; // 強制 reflow
            group.style.height = "0px"; // 收起動畫
            group.classList.add("group-hidden-height");
            group.classList.remove("mobile-group-active");
          }
        }
      });
      // const subGroups = document.querySelectorAll(
      //   ".navbar-mobile-sub-group-container"
      // );
      // subGroups.forEach((group) => {
      //   if (!group.classList.contains("sub-group-hidden-height")) {
      //     group.classList.add("sub-group-hidden-height");
      //     group.classList.remove("mobile-sub-group-active");
      //   }
      // });

      const target = document.getElementById(`navMob${name}`);

      if (target.classList.contains("group-hidden-height")) {
        // 展開
        target.style.height = target.scrollHeight + "px";
        target.classList.remove("group-hidden-height");
        target.classList.add("mobile-group-active");

        // 移除內聯高度，讓高度自動適應（動畫結束後）
        target.addEventListener("transitionend", function onEnd() {
          target.style.height = "auto";
          target.removeEventListener("transitionend", onEnd);
        });
      } else {
        // 收起
        target.style.height = target.scrollHeight + "px"; // 設定目前高度
        target.offsetHeight; // 強制 reflow
        target.style.height = "0px";
        target.classList.add("group-hidden-height");
        target.classList.remove("mobile-group-active");
      }
      if (name == "Download") {
        this.$router.push({
          name: "Download",
        });
      }
    },
    openNavbarMobileSubGroup(name) {
      const groups = document.querySelectorAll(
        ".navbar-mobile-sub-group-container"
      );
      groups.forEach((group) => {
        if (group.id !== `navMobSub${name}`) {
          if (!group.classList.contains("sub-group-hidden-height")) {
            group.style.height = group.scrollHeight + "px";
            group.offsetHeight;
            group.style.height = "0px";
            group.classList.add("sub-group-hidden-height");
            group.classList.remove("mobile-sub-group-active");
          }
        }
      });

      const target = document.getElementById(`navMobSub${name}`);

      if (target.classList.contains("sub-group-hidden-height")) {
        target.style.height = target.scrollHeight + "px";
        target.classList.remove("sub-group-hidden-height");
        target.classList.add("mobile-sub-group-active");

        target.addEventListener("transitionend", function onEnd() {
          target.style.height = "auto";
          target.removeEventListener("transitionend", onEnd);
        });
      } else {
        target.style.height = target.scrollHeight + "px";
        target.offsetHeight;
        target.style.height = "0px";
        target.classList.add("sub-group-hidden-height");
        target.classList.remove("mobile-sub-group-active");
      }
    },
    openNavbarMobile() {
      const ngl = this.$refs.navbarGrayLayer;
      const nmc = this.$refs.navbarMobileContainer;
      if (!ngl || !nmc) return;

      this.cancelMobileNavbarCollapse();
      this.isMobileNavbarOpen = true;
      ngl.classList.add("show-navbar-gray-layer");
      nmc.classList.remove("hide-navbar-mobile");
    },
    closeNavbarMobile() {
      const ngl = this.$refs.navbarGrayLayer;
      const nmc = this.$refs.navbarMobileContainer;
      if (!ngl || !nmc) return;
      const isAlreadyHidden = nmc.classList.contains("hide-navbar-mobile");

      this.isMobileNavbarOpen = false;
      ngl.classList.remove("show-navbar-gray-layer");
      nmc.classList.add("hide-navbar-mobile");

      // 路由 watcher 可能重複呼叫；既有的收合流程會在動畫結束後處理群組。
      if (isAlreadyHidden) return;

      this.cancelMobileNavbarCollapse();
      const finishCollapse = () => {
        if (this.mobileNavbarTransitionHandler) {
          nmc.removeEventListener(
            "transitionend",
            this.mobileNavbarTransitionHandler
          );
        }
        if (this.mobileNavbarCloseTimer) {
          clearTimeout(this.mobileNavbarCloseTimer);
        }

        this.mobileNavbarTransitionHandler = null;
        this.mobileNavbarCloseTimer = null;

        if (nmc.classList.contains("hide-navbar-mobile")) {
          this.collapseNavbarMobileGroups();
        }
      };

      this.mobileNavbarTransitionHandler = (event) => {
        if (event.target === nmc && event.propertyName === "transform") {
          finishCollapse();
        }
      };
      nmc.addEventListener("transitionend", this.mobileNavbarTransitionHandler);

      // 防止瀏覽器未觸發 transitionend 時，群組狀態永遠不重設。
      this.mobileNavbarCloseTimer = setTimeout(finishCollapse, 350);
    },
    collapseNavbarMobileGroups() {
      const groups =
        this.$refs.navbarMobileContainer?.querySelectorAll(
          ".navbar-mobile-group-container"
        ) || [];
      groups.forEach((group) => {
        if (!group.classList.contains("group-hidden-height")) {
          group.classList.add("group-hidden-height");
          group.classList.remove("mobile-group-active");
        }
      });
    },
    cancelMobileNavbarCollapse() {
      const nmc = this.$refs.navbarMobileContainer;
      if (nmc && this.mobileNavbarTransitionHandler) {
        nmc.removeEventListener(
          "transitionend",
          this.mobileNavbarTransitionHandler
        );
      }
      if (this.mobileNavbarCloseTimer) {
        clearTimeout(this.mobileNavbarCloseTimer);
      }
      this.mobileNavbarTransitionHandler = null;
      this.mobileNavbarCloseTimer = null;
    },
    loadNavbarItems() {
      this.navbars = this.$enum.navbarGroupType.getAll();
      this.filteredNavbars = this.filterNode(this.navbars);
    },
    refreshNavbarItems() {
      this.isNavbarLoading = true;

      return this.$api.employees
        .getAuthoritys()
        .then((data) => {
          if (!Array.isArray(data?.Authoritys)) {
            throw new Error("選單權限資料格式錯誤");
          }

          const roleType = this.$enum.roleType.normalize(data.RoleType);
          if (roleType !== null) {
            window.localStorage["roleType"] = roleType;
          }
          this.$func.localStorage.setAuth(data.Authoritys);
          this.loadNavbarItems();
          window.localStorage["setStoreId"] = data.StoreId;
          window.localStorage["setProductType"] = data.ProductType;
          window.localStorage["inventoryMachineType"] =
            data.InventoryMachineType;
        })
        .catch((error) => {
          // API 異常時保留先前有效的權限快取，避免把手機選單清成空白。
          if (!this.filteredNavbars.length) this.loadNavbarItems();
          this.$func.message({
            type: "error",
            mainMessage:
              error?.data?.Message || error?.message || "無法讀取選單權限",
          });
        })
        .finally(() => {
          this.isNavbarLoading = false;
          this.navbarItemsLoaded = true;
        });
    },
    openNotify() {},
    backToHome() {
      if (this.$route.name != "Home") {
        this.$router.push({ name: "Home" });
      }
    },
    changeRoute(item) {
      if (!item.subcategories) {
        this.$router.push({
          name: item.name,
        });
      }
      this.hideNavbarActiveContent();
    },
    showSubContent(value, category) {
      if (value == 1) {
        const currentCat = document.getElementById(category.name);
        const cats = document.querySelectorAll(
          ".navbar-active-main-content-item"
        );
        cats.forEach((cat) => {
          cat.classList.remove("active");
        });
        currentCat.classList.add("active");
        this.$refs.navbarActiveSubContent.classList.add("active");
        this.subGroup = category;

        const nl = document.querySelector(".navbar-left");
        nl.removeEventListener("mouseleave", this.hideNavbarActiveContent);
        setTimeout(() => {
          const nl = document.querySelector(".navbar-left");
          nl.addEventListener("mouseleave", this.hideNavbarActiveContent);
        }, 500);
      } else {
        this.changeRoute(category);
      }
    },
    hideSubContent() {
      this.$refs.navbarActiveSubContent.classList.remove("active");
      const cats = document.querySelectorAll(
        ".navbar-active-main-content-item"
      );
      cats.forEach((cat) => {
        cat.classList.remove("active");
      });
    },
    showNavbarActiveContent(value) {
      this.group = this.filteredNavbars.find((nav) => nav.value == value);
      const currentCat = document.getElementById(this.group.name);
      const cats = document.querySelectorAll(".navbar-link");
      cats.forEach((cat) => {
        cat.classList.remove("active");
      });
      currentCat.classList.add("active");
      this.$refs.navbarActiveContent.classList.add("active");
      this.hideSubContent();
      setTimeout(() => {
        const nl = document.querySelector(".navbar-left");
        nl.addEventListener("mouseleave", this.hideNavbarActiveContent);
      }, 500);
    },
    hideNavbarActiveContent() {
      this.$refs.navbarActiveContent.classList.remove("active");
      this.hideSubContent();
      const cats = document.querySelectorAll(".navbar-link");
      cats.forEach((cat) => {
        cat.classList.remove("active");
      });
      const nl = document.querySelector(".navbar-left");
      nl.removeEventListener("mouseleave", this.hideNavbarActiveContent);
    },
  },
  created() {
    if (!this.isGeneralUser) {
      this.loadNavbarItems();
      this.navbarItemsLoaded = true;
      return;
    }
    if (window.localStorage["authorities"]) {
      this.loadNavbarItems();
    }
    if (window.localStorage.token) {
      this.refreshNavbarItems();
    } else {
      this.navbarItemsLoaded = true;
    }
  },
  beforeUnmount() {
    this.cancelMobileNavbarCollapse();
    document.removeEventListener("click", this.closeUserModal, true);
  },
};
</script>

<style lang="scss" scoped>
.navbar-links.component-development-enabled {
  justify-content: flex-start;
  flex: 1;
  min-height: 0;
  padding-bottom: 15px;
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.navbar-logo {
  flex-shrink: 0;
}

.navbar-mobile-toggle {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 44px;
  height: 44px;
  padding: 11px 7px;
  border: 0;
  background: transparent;
  @media screen and (min-width: 992px) {
    display: none;
  }
}
.navbar-gray-layer {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1110;
  background-color: rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
  @media screen and (min-width: 992px) {
    display: none;
  }
}
.show-navbar-gray-layer {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}
.navbar-mobile-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: white;
  color: #212121;
  width: 320px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1120;
  box-shadow: 3px 0 6px 0px #00000029;
  transform: translateX(0);
  transition: transform 0.3s;
  .close-btn {
    cursor: pointer;
    width: 100%;
    text-align: end;
    font-size: 28px;
    font-weight: 700;
    padding: 10px 20px 0;
  }
  .navbar-mobile-groups {
    width: 100%;
    overflow: auto;
    box-sizing: border-box;
  }
  @media screen and (min-width: 992px) {
    display: none;
  }
}
.navbar-mobile-status {
  width: 100%;
  padding: 24px 20px;
  color: #6c757d;
  text-align: center;
}
.hide-navbar-mobile {
  transform: translateX(-100%);
  box-shadow: none;
}
.navbar-mobile-group-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  transition: all 0.3s;
  .navbar-mobile-links {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    padding-left: 45px;
    .navbar-mobile-link {
      cursor: pointer;
      width: 100%;
      padding: 10px 0;
      font-weight: 500;
      a {
        display: block;
        width: 100%;
        text-decoration: none;
        color: #43434e;
        transition: all 0.3s;
      }
      &:hover {
        a {
          color: #3e5ba9;
        }
      }
    }
  }
}
.navbar-mobile-group {
  cursor: pointer;
  width: 100%;
  padding: 20px 20px 10px;
  font-size: 18px;
  font-weight: 500;
  color: #43434e;
  transition: all 0.3s;
  svg {
    font-size: 16px;
    margin: 0 0 1px 10px;
    transition: all 0.7s;
  }
}
.mobile-group-active {
  .navbar-mobile-group {
    color: #3e5ba9 !important;
    svg {
      transform: rotate3d(1, 0, 0, 180deg);
    }
  }
}
.group-hidden-height {
  height: 57px !important;
}
.navbar-mobile-logo {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  margin-left: 16px;
  .navbar-logo-img {
    width: 100%;
  }
  @media screen and (min-width: 992px) {
    display: none;
  }
}
.navbar-mobile-sub-group-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  transition: all 0.3s;
}
.navbar-mobile-sub-group {
  cursor: pointer;
  width: 100%;
  padding: 12px 0 12px;
  color: #43434e;
  font-weight: 500;
}
.mobile-sub-group-active {
  .navbar-mobile-sub-group {
    color: #3e5ba9 !important;
    svg {
      transform: rotate3d(1, 0, 0, 180deg);
    }
  }
}
.sub-group-hidden-height {
  height: 48px !important;
}
.navbar-mobile-sub-links {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding-left: 24px;
}
.navbar-mobile-sub-link {
  cursor: pointer;
  width: 100%;
  padding: 10px 0;
  font-weight: 500;
  a {
    display: block;
    width: 100%;
    text-decoration: none;
    color: #43434e;
    transition: all 0.3s;
  }
  &:hover {
    a {
      color: #3e5ba9;
    }
  }
}
.go-old-cloud {
  display: flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 16px;
  transition: all 0.3s;
  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #4695c9;
    margin-bottom: 2px;
    transition: all 0.3s;
    img {
      margin-top: 1px;
      margin-right: 5px;
    }
  }
  &:hover {
    a {
      filter: brightness(1.2);
    }
  }
}
.manual-hover::after {
  content: attr(data-title);
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 300;
  white-space: nowrap;
  border-radius: 4px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s;
}
.manual-hover:hover::after {
  opacity: 1;
}
</style>
